module.exports = __webpack_public_path__ + "static/media/design2.07a0e432.png";